export type UsageHistoryPeriod = {
  date: Date;
  usedMinutes: number;
};

export enum UsageHistoryPeriodType {
  month = 'MONTH',
}
